import styles from "./PriceButton.module.scss";

export const PriceHighlighted = ({ finalPriceObj, optionalAttribute }) => {
  return (
    /* If varBig empty then only render basePrice  */
    <div className={`price ${styles.price}`} {...optionalAttribute}>
      <span className={styles.left}>{finalPriceObj && finalPriceObj.basePrice ? finalPriceObj.basePrice : ""}</span>

      {finalPriceObj ? (
        finalPriceObj.varBig && (
          <>
            <span className={`bigNum ${styles.bigNum}`}>
              <div>
                <span>{finalPriceObj.varBig}</span>
              </div>
            </span>
            <span className={styles.right}>{finalPriceObj?.varSm ? finalPriceObj.varSm : ""}</span>
          </>
        )
      ) : (
        <span className={styles.blank}>&mdash;</span>
      )}
    </div>
  );
};
